import {
  WithStyles,
  Theme,
  createStyles,
  withStyles,
  Dialog,
  DialogTitle,
  Divider,
  DialogContent,
  Typography,
  IconButton,
} from "@material-ui/core";
import * as React from "react";
import { colors } from "../constants/constants";
import CloseIcon from "@material-ui/icons/Close";
const drawerWidth = 340;
const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    button: {
      margin: theme.spacing(1),
      width: "30%",
      height: 48,
    },
    paper: {
      padding: theme.spacing(1) * 2,
      textAlign: "center",
      height: "100%",
      color: theme.palette.text.secondary,
    },
    control: {
      padding: theme.spacing(1) * 2,
    },
    appBar: {
      [theme.breakpoints.up("sm")]: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
      },
    },
    menuHideButton: {
      marginRight: theme.spacing(2),
      [theme.breakpoints.up("sm")]: {
        display: "none",
      },
    },
    margin: {
      margin: theme.spacing(1),
    },
    menuShowButton: {
      marginRight: theme.spacing(2),
      [theme.breakpoints.up("sm")]: {
        display: "visible",
      },
      color: "black",
    },
    extendedIcon: {
      marginRight: theme.spacing(1),
    },
    sectionDesktop: {
      display: "none",
      [theme.breakpoints.up("md")]: {
        display: "flex",
      },
    },
    avatar: {
      backgroundColor: colors.primaryColor,
      color: "#ffff",
    },
    toolbar: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      paddingTop: 0,
      paddingBottom: 8,
      minHeight: 64,
    },
    nested: {
      paddingLeft: theme.spacing(4),
    },
    drawerPaper: {
      width: drawerWidth,
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
    large: {
      margin: 10,
      width: theme.spacing(15),
      height: theme.spacing(15),
    },
  });
interface Props extends WithStyles<typeof styles> {
  open: any;
  dialogTitle: any;
  imageItem: any;
  onClose: any;
}
class ViewImageDialog extends React.Component<Props> {
  state = {};
  handleClose = () => {
    this.props.onClose();
  };
  componentDidMount = () => {};

  componentDidUpdate = () => {};

  render() {
    const { open, dialogTitle, classes, imageItem, onClose } = this.props;
    return (
      <React.Fragment>
        <Dialog
          fullWidth={true}
          maxWidth={"md"}
          open={open}
          onClose={onClose}
          aria-labelledby="max-width-dialog-title"
        >
          <DialogTitle disableTypography className={classes.root}>
            <Typography variant="h6">{dialogTitle}</Typography>
            {onClose ? (
              <IconButton
                aria-label="close"
                className={classes.closeButton}
                onClick={onClose}
              >
                <CloseIcon />
              </IconButton>
            ) : null}
          </DialogTitle>
          <Divider />
          <DialogContent>
            <img
              src={`data:image/jpeg;base64,${imageItem.base64}`}
              alt={"mainPic-issueItem"}
              style={{ height: "100", width: "100%" }}
            />
          </DialogContent>
        </Dialog>
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(ViewImageDialog);
